export default __webpack_public_path__ + "static/media/waste-water.28c293c9.webp";